import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  background-color: white;
`
